import { render } from "lit-html"

import components from "./js/profile"

document.addEventListener("DOMContentLoaded", () => {
  const onClickTab = (el) => {
    el.preventDefault()
    const $tab = el.target
    if (
      $tab.classList.contains("tab-active") ||
      $tab.classList.contains("tab-inactive")
    ) {
      return
    }

    const $currentTab = document.querySelector("#profile-nav .tab-active")
    if ($currentTab) {
      $currentTab.classList.remove("text-black", "tab-active")
      $currentTab.classList.add("text-blue")
      const $currentSection = document.getElementById(
        $currentTab.dataset.section
      )
      $currentSection.classList.add("hidden")
    }

    $tab.classList.remove("text-blue")
    $tab.classList.add("text-black", "tab-active")
    window.history.replaceState({}, window.document.title, $tab.href)

    const sectionId = $tab.dataset.section
    const $section = document.getElementById(sectionId)
    $section.classList.remove("hidden")

    const $componentContainers = $section.querySelectorAll(".component")
    $componentContainers.forEach(($container) => {
      const Component = components[$container.dataset.component]
      const endpoint = $container.dataset.endpoint
      render(Component({ endpoint }), $container)
    })
  }

  const $tabs = document.querySelectorAll("#profile-nav .tab")
  $tabs.forEach(($tab) => {
    $tab.addEventListener("click", onClickTab)
  })

  const $currentTab = document.querySelector(
    `#profile-nav .tab[href="${window.location.hash}"]`
  )
  if ($currentTab && !$currentTab.classList.contains("tab-inactive")) {
    $currentTab.click()
  } else {
    $tabs[0] && $tabs[0].click()
  }

  document.querySelectorAll(".assignment-card").forEach(($assignmentCard) => {
    const ASSIGNMENT_THRESHOLD = 3
    const $assignmentRows = $assignmentCard.querySelectorAll(".assignment-row")
    const $firstActiveRows = Array.from($assignmentRows).slice(
      0,
      ASSIGNMENT_THRESHOLD
    )
    const $showOption = $assignmentCard.querySelector("a.show-option")

    if ($showOption) {
      if ($assignmentRows.length > ASSIGNMENT_THRESHOLD) {
        $showOption.classList.remove("hidden")

        $showOption.addEventListener("click", () => {
          $showOption.classList.toggle("expanded")
          $assignmentRows.forEach(($el) => $el.classList.toggle("hidden"))
          $firstActiveRows.forEach(($el) => $el.classList.remove("hidden"))
        })
      }

      const $displayingRows = $showOption.classList.contains("expanded")
        ? $assignmentRows
        : $firstActiveRows
      $displayingRows.forEach(($el) => $el.classList.remove("hidden"))
    }
  })

  window.copyProfileUrl = (e) => {
    e.preventDefault()
    const $button = document.querySelector("[data-action='copy-profile-url']")
    navigator.clipboard.writeText($button.dataset.profileUrl)
    $button.classList.add("copied")
    setTimeout(() => {
      $button.classList.remove("copied")
    }, 1000)
  }
})
